import React from 'react';
import { Link } from "react-router-dom";
import PropTypes from 'prop-types';
import withStyles from '@mui/styles/withStyles';

import Button from '@mui/material/Button';
import IconButton from '@mui/material/IconButton';
import Snackbar from '@mui/material/Snackbar';
import SnackbarContent from '@mui/material/SnackbarContent';

import InfoIcon from '@mui/icons-material/Info';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import WarningIcon from '@mui/icons-material/Warning';
import ErrorIcon from '@mui/icons-material/Error';
import CloseIcon from '@mui/icons-material/Close';

// TODO basculer vers le theme
import { green, amber, blue } from '@mui/material/colors';

const variantIcon = {
    information: InfoIcon,
    success: CheckCircleIcon,
    warning: WarningIcon,
    error: ErrorIcon
};

const styles = theme => ({
    root: {
        margin: theme.spacing(1)
    },

    information: {
        backgroundColor: blue[700]
    },

    success: {
        backgroundColor: green[600]
    },

    warning: {
        backgroundColor: amber[700]
    },

    error: {
        backgroundColor: theme.palette.error.dark
    },

    message: {
        display: 'flex',
        alignItems: 'center',
        whiteSpace: 'pre-line'
    },

    snackbarIcon: {
        fontSize: 20,
        marginRight: theme.spacing(1)
    }
});

const NotificationSnackbar = ({ classes, key, open, onClose, message, importance, closable, url }) => {

    let Icon = variantIcon[importance];

    return (
        <Snackbar key={key} anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }} open={open} className={classes.root} autoHideDuration={closable ? null : 6000} onClose={onClose} disableWindowBlurListener>
            <SnackbarContent
                className={classes[importance]}
                message={
                    <span className={classes.message}>
                        <Icon className={classes.snackbarIcon} />
                        {message}
                    </span>
                }
                action={[
                    (url !== null || closable) && (
                        <React.Fragment key={Math.trunc(Math.random() * 1000000000000)}>
                            {url !== null && (
                                <Link to={url}>
                                    <Button>Voir</Button>
                                </Link>
                            )}
                            {closable && (
                                <IconButton onClick={onClose} size="large">
                                    <CloseIcon />
                                </IconButton>
                            )}
                        </React.Fragment>
                    )
                ]}
            />
        </Snackbar>
    );
};

NotificationSnackbar.propTypes = {
    classes: PropTypes.object.isRequired,
    closable: PropTypes.bool.isRequired,
    importance: PropTypes.string.isRequired,
    message: PropTypes.string.isRequired,
    onClose: PropTypes.func.isRequired,
    open: PropTypes.bool.isRequired,
    url: PropTypes.string
};

export default withStyles(styles)(NotificationSnackbar);